import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import moment from 'moment';
import RHFTextField from '../../components/hook-form/RHFTextField'; // Adjust path as necessary
import { RHFCheckbox } from '../../components/hook-form/RHFCheckbox'; // Adjust path as necessary



const StyledModal = styled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const ModalContent = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(4),
  width: '400px',
}));

const EventModal = ({ open, onClose, eventData, onSave, handleDelete }) => {
  const methods = useForm({
    defaultValues: {
      title: '',
      start: '',
      end: '',
      allDay: false,
    },
  });

  const { handleSubmit, reset } = methods;

  // Update form values when eventData changes
  useEffect(() => {
    if (eventData) {
      reset({
        title: eventData.title,
        start: moment(eventData.start).format('YYYY-MM-DDTHH:mm'), // Format for datetime-local
        end: moment(eventData.end).format('YYYY-MM-DDTHH:mm'),     // Format for datetime-local
        allDay: eventData.allDay,
      });
    }
  }, [eventData, reset]);

  const handleFormSubmit = (data) => {
    onSave(data);
    onClose();
  };

  return (
    <StyledModal open={open} onClose={onClose}>
      <ModalContent>
        <Typography variant="h6" gutterBottom>
          {eventData ? 'Edit Event' : 'Add Event'}
        </Typography>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <RHFTextField name="title" label="Event Title" required />
            <RHFTextField name="start" label="Start Time" type="datetime-local" />
            <RHFTextField name="end" label="End Time" type="datetime-local" />
            <RHFCheckbox name="allDay" label="All Day Event" />
            <br />

            <Button type="submit" variant="contained" color="primary">
              Save Event
            </Button>&nbsp;
            {eventData && (
              <Button type="button" variant="contained" color="secondary" onClick={handleDelete}>
                Delete Event
              </Button>
            )}
            <Button type="button" onClick={onClose}>
              Cancel
            </Button>
          </form>
        </FormProvider>
      </ModalContent>
    </StyledModal>
  );
};

EventModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  eventData: PropTypes.object,
  onSave: PropTypes.func.isRequired,
};

export default EventModal;
